import { DateTime } from 'luxon';

import { Demographic } from '@/common/models';
import { DASH } from '@/globals';
import Validatable from '@/validator/Validatable';
import i18n from '@/vueI18n';

export interface IAudienceFileAPI {
  audiencefile_id: number;
  file_name: string;
  url: string;
  demographic_id: number;
  created_on_utc: string;
  modified_on_utc: string;
}

export default class AudienceFile extends Validatable {
  name: string;

  reportFileUrl: string;

  demographicID: number;

  createdOnUtc: DateTime;

  modifiedOnUtc: DateTime;

  demographic: Demographic;

  constructor(
    id = -1,
    name: string,
    reportFileUrl: string,
    demographicID: number,
    createdOnUtc: DateTime,
    modifiedOnUtc: DateTime,
  ) {
    super();
    this.id = id;
    this.name = name;
    this.reportFileUrl = reportFileUrl;
    this.demographicID = demographicID;
    this.createdOnUtc = createdOnUtc;
    this.modifiedOnUtc = modifiedOnUtc;
    this.demographic = null;
  }

  static fromObject(obj: AudienceFile): AudienceFile {
    return super.fromObject(
      obj,
      new AudienceFile(obj.id, obj.name, obj.reportFileUrl, obj.demographicID, obj.createdOnUtc, obj.modifiedOnUtc),
    );
  }

  static fromApi(apiObject: IAudienceFileAPI): AudienceFile {
    return new AudienceFile(
      apiObject.audiencefile_id,
      apiObject.file_name != null ? window.decodeURI(apiObject.file_name) : null,
      apiObject.url,
      apiObject.demographic_id,
      apiObject.created_on_utc != null ? DateTime.fromISO(apiObject.created_on_utc, { zone: 'utc' }) : null,
      apiObject.modified_on_utc != null ? DateTime.fromISO(apiObject.modified_on_utc, { zone: 'utc' }) : null,
    );
  }

  get modifiedOnFormatted(): string {
    return this.modifiedOnUtc != null ? this.modifiedOnUtc.toLocal().toLocaleString(DateTime.DATETIME_MED) : DASH;
  }

  getExtraValidation(): Record<string, any> {
    const extras: Record<string, any> = {};
    if (this.name.localeCompare(this.name.match(/[\w\s%]+/g)!.join('')) !== 0) {
      extras.name = {
        message: i18n.global.t('messages.filenameMustOnlyContainWordsAndWhitespace'),
        preEvaluated: true,
      };
    }
    return extras;
  }

  static validatorCreateRules(): Record<string, string> {
    return {
      name: 'required|max:100|not_empty_or_whitespace',
    };
  }
}
